import { writable } from 'svelte/store';
import ThumbDraftService from '../../services/thumbdraft';
import { step } from '@/store';
const draftService = new ThumbDraftService();
const initialState = writable({
    currentDraft: null,
    savedToCloud: false,
    currentCloudDraftId: null,
    currentStep: null,
    isProject: false,
    metadata: {},
    isSaving: false
});
const { subscribe, set, update } = initialState;
let draftState;
subscribe(draft => (draftState = draft));
let currentStep;
step.subscribe(s => {
    if (s !== null)
        currentStep = s;
});
let abortController = null;
let currentRequest = null;
let currentUpdate = null;
const thumbDraft = {
    subscribe,
    set,
    createNewDraft: async (project, metadata = null, name, type = 'quote') => {
        if (!project.video)
            return console.log('PROJECT HAS NO VIDEO ID');
        const draft = await draftService.create({
            project,
            video: project.video.id,
            projectName: name,
            currentStep: currentStep,
            type: project.type ? project.type : type
        });
        update(store => {
            return {
                ...store,
                currentDraft: project,
                savedToCloud: true,
                currentCloudDraftId: draft.id,
                currentStep: draft.currentStep,
                projectName: draft.projectName,
                isProject: draft.isProject,
                isSaving: false,
                metadata,
                restored: false,
                type
            };
        });
    },
    duplicateDraft: async (draftid) => {
        if (!draftid || isNaN(draftid) || draftid <= 0) {
            console.log('PROJECT HAS NO ID');
            return false;
        }
        const data = await draftService.duplicate(String(draftid));
        return data.result === true;
    },
    updateDraft: async (project, name, metadata) => {
        if (currentUpdate)
            clearTimeout(currentUpdate);
        if (!project.video)
            return;
        currentUpdate = setTimeout(async () => {
            if (draftState.currentCloudDraftId) {
                update(store => ({ ...store, isSaving: true }));
                await draftService.update(draftState.currentCloudDraftId, {
                    project,
                    projectName: name,
                    currentStep: currentStep,
                    metadata
                });
                update(store => ({
                    ...store,
                    currentDraft: project,
                    projectName: name,
                    currentStep: currentStep,
                    metadata,
                    isSaving: false
                }));
            }
            else {
                console.warn('No Quote Draft ID');
            }
            currentUpdate = null;
        }, 500);
    },
    updateDraftClip: async (id, project, name) => {
        if (currentUpdate)
            clearTimeout(currentUpdate);
        return new Promise(resolve => {
            currentUpdate = setTimeout(async () => {
                if (project.video === null || project.template === null)
                    return resolve(false);
                if (!id)
                    return resolve(false);
                if (abortController)
                    abortController.abort();
                abortController = new AbortController();
                try {
                    await draftService.update(id, { projectName: name }, { signal: abortController.signal });
                    abortController = null;
                }
                catch (error) {
                    console.log('clip update failed', error);
                }
                return resolve(true);
            }, 500);
        });
    },
    renameDraftClip: async (id, project, name) => {
        if (currentUpdate)
            clearTimeout(currentUpdate);
        return new Promise(resolve => {
            currentUpdate = setTimeout(async () => {
                if (project.video === null || project.template === null)
                    return resolve(false);
                if (!id || !name)
                    return resolve(false);
                if (abortController)
                    abortController.abort();
                abortController = new AbortController();
                try {
                    await draftService.rename(id, { projectName: name });
                    abortController = null;
                }
                catch (error) {
                    console.log('clip update failed', error);
                }
                return resolve(true);
            }, 500);
        });
    },
    markDraftAsProject: async (projectName, id) => {
        update(store => ({ ...store, isSaving: true }));
        if (id) {
            await draftService.makeProject(id, projectName);
        }
        update(store => ({ ...store, isProject: true, isSaving: false, projectName }));
    },
    markDraftCompleted: () => { },
    markDraftIncomplete: () => { },
    resetState() {
        update(store => ({
            ...store,
            currentDraft: null,
            savedToCloud: false,
            currentCloudDraftId: null,
            projectName: '',
            currentStep: null,
            isProject: false,
            metadata: {},
            isSaving: false
        }));
    }
};
export default thumbDraft;
function debounceRequest(project, name, metadata) {
    if (currentRequest)
        clearTimeout(currentRequest);
    currentRequest = setTimeout(() => {
        createDraftRequest(project, name, metadata);
        currentRequest = null;
    }, 750);
}
function createDraftRequest(project, name, metadata) {
    if (abortController)
        abortController.abort(); // Cancels the previous request
    abortController = new AbortController();
    return draftService
        .update(draftState.currentCloudDraftId, { project, projectName: name, currentStep, metadata }, { signal: abortController.signal })
        .then(resp => (abortController = null));
}
